// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISsnInfoDto
 */
export interface ISsnInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ISsnInfoDto
     */
    ssn?: string;
}

/**
 * Check if a given object implements the ISsnInfoDto interface.
 */
export function instanceOfISsnInfoDto(value: object): value is ISsnInfoDto {
    return true;
}

export function ISsnInfoDtoFromJSON(json: any): ISsnInfoDto {
    return ISsnInfoDtoFromJSONTyped(json, false);
}

export function ISsnInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISsnInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
    };
}

export function ISsnInfoDtoToJSON(json: any): ISsnInfoDto {
    return ISsnInfoDtoToJSONTyped(json, false);
}

export function ISsnInfoDtoToJSONTyped(value?: ISsnInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ssn': value['ssn'],
    };
}

